export { default as Img200 } from './processed/200/DrainTheOceans_NetEffects.jpg';
export { default as Img400 } from './processed/400/DrainTheOceans_NetEffects.jpg';
export { default as Imgthumb } from './processed/thumb/DrainTheOceans_NetEffects.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/DrainTheOceans_NetEffects.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/DrainTheOceans_NetEffects.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      202,
      146,
      81
    ],
    "_population": 56,
    "_hsl": [
      0.08953168044077135,
      0.5330396475770924,
      0.5549019607843138
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      209,
      152
    ],
    "_population": 653,
    "_hsl": [
      0.11309523809523807,
      0.6885245901639346,
      0.7607843137254902
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      100,
      61,
      28
    ],
    "_population": 85,
    "_hsl": [
      0.0763888888888889,
      0.5625,
      0.25098039215686274
    ]
  },
  "Muted": {
    "_rgb": [
      152,
      120,
      89
    ],
    "_population": 2260,
    "_hsl": [
      0.08201058201058202,
      0.26141078838174275,
      0.4725490196078431
    ]
  },
  "LightMuted": {
    "_rgb": [
      193,
      169,
      143
    ],
    "_population": 165,
    "_hsl": [
      0.08666666666666666,
      0.2873563218390804,
      0.6588235294117647
    ]
  },
  "DarkMuted": {
    "_rgb": [
      78,
      59,
      48
    ],
    "_population": 2737,
    "_hsl": [
      0.061111111111111116,
      0.23809523809523814,
      0.24705882352941178
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/DrainTheOceans_NetEffects.js